import {
  SET_BIG_WINS_COUNTRIES,
  SET_BIG_WINS_CURRENCY,
  SET_BIG_WINS_DATA,
  SET_BIG_WINS_DATA_TO_QUEUE,
  SET_BIG_WINS_HISTORY_LOADED,
} from '../../../../constants/centrifugo';

export const setBigWins = (payload) => ({
  type: SET_BIG_WINS_DATA,
  payload,
});

export const setBigWinsToQueue = (payload) => ({
  type: SET_BIG_WINS_DATA_TO_QUEUE,
  payload,
});

export const setBigWinsHistoryLoaded = () => ({
  type: SET_BIG_WINS_HISTORY_LOADED,
});

export const setBigWinsCurrency = (payload) => ({
  type: SET_BIG_WINS_CURRENCY,
  payload,
});

export const setBigWinsCountries = (payload) => ({
  type: SET_BIG_WINS_COUNTRIES,
  payload,
});
